import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import '../styles/preview.css';
import config from '../config';

import getCroppedImg from "./croppedImage";

import Cropper from 'react-easy-crop'

import { pdfjs } from "react-pdf";

const host = config.backendUrl;

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const GroupedModal = ({ isOpen, modals, choices, onModalClose, onSave }) => {
    const [modalInputs, setModalInputs] = useState({});
    const [loading, setLoading] = useState(false);

    const [image, setImage] = useState(null)
    const [scale, setScale] = useState(1)

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [rotation, setRotation] = useState(0)
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null)

    const [showCropper, setShowCropper] = useState(false);

    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
      }
    
      const showCroppedImage = async (modalName) => {
        try {
          const croppedImage = await getCroppedImg(
            image,
            croppedAreaPixels,
            rotation
          )

          setCroppedImage(croppedImage.url)

          const croppedFile = new File([croppedImage.file], 'cropped-image.jpg', { type: 'image/jpeg' });

            setModalInputs((prev) => ({
                ...prev,
                [modalName]: croppedFile
            }));

        } catch (e) {
          console.error(e)
        }
      }


    useEffect(() => {
        if (isOpen) {
            const initialInputs = {};
            modals.forEach(modal => {
                if (choices[modal.name] !== undefined) {
                    initialInputs[modal.name] = choices[modal.name];
                }
            });
            setModalInputs(initialInputs);
        }
    }, [isOpen, choices, modals]);

    const handleClickOutside = (event) => {
        if (event.target.className === 'modal-overlay') {
            onModalClose();
        }
    };

    useEffect(() => {
        if (isOpen) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'unset';
        }
        return () => {
          document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    const limitRows = (e, limit) => {
        let vals = e.target.value.replace(/\r\n/g,"\n").split("\n")
        if (vals.length > limit) {
            e.target.value = vals.slice(0, limit).join("\n")
        }
    }

    useEffect(() => {
        if (!isOpen) {
            setModalInputs({});
        }
    }, [isOpen]);

    const renderInput = ({modal}) => {
        switch (modal.modalType) {
            case 'text':
                return (
                    <>
                    <div className="modal-text-input-container">
                        <input
                            type="text"
                            maxLength={modal.maxCharacters}
                            placeholder="Enter your text"
                            value={modalInputs[modal.name] || ''}
                            onChange={(e) => setModalInputs(prev => ({
                                ...prev,
                                [modal.name]: e.target.value
                            }))}
                            className="modal-text-input"
                        />
                        <button 
                            className="modal-text-input-clear"
                            onClick={() => {
                                setModalInputs(prev => ({
                                    ...prev,
                                    [modal.name]: ''
                                }))
                            }
                            }
                        >
                           Clear
                        </button>
                    </div>
                         <div className="modal-textarea-characters">
                            {modal.maxCharacters - (modalInputs[modal.name] || '').length} characters remaining
                        </div>
                        <br />
                    </>
                );
            case 'textarea':    
                return (
                    <>
                    <textarea
                        maxLength={modal.maxCharacters}
                        placeholder={modal.placeholder || ''} 
                        value={modalInputs[modal.name] || ''}
                        cols={modal.cols}
                        rows={modal.rows}
                        onChange={(e) => {
                            limitRows(e, modal.rows)
                            setModalInputs(prev => ({
                                ...prev,
                                [modal.name]: e.target.value
                            }))
                        }}
                        className="modal-textarea"
                    />
                    <div className="modal-textarea-characters">
                        {modal.maxCharacters - (modalInputs[modal.name] || '').length} characters remaining
                    </div>
                    <br />
                    </>
                );
            case 'multiple-choice':
                return (
                    <select
                        value={modalInputs[modal.name] || ''}
                        onChange={(e) => setModalInputs(prev => ({
                            ...prev,
                            [modal.name]: e.target.value
                        }))}
                        className="modal-select"
                    >
                        <option value="" disabled>Select an option</option>
                        {modal.choices
                            .filter(choice => {
                                if (!choice.exclusion_condition) return true;
                                return !(choices[choice.exclusion_condition.key] == choice.exclusion_condition.value);
                            })
                            .map((choice, index) => (
                                <option key={index} value={choice.value}>{choice.label}</option>
                            ))}
                    </select>
                );

            case 'photo': 
                return (
                    <>
                        <div className="image-input-container">
                        <label for="image-input" class="image-input-label">
                            Upload a photo
                        </label>
                            <input
                                type="file"
                                accept="image/jpeg, image/png"
                                className="image-input"
                                id="image-input"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        if (file.size > 10 * 1024 * 1024) { // Check if file size exceeds 5 MB
                                            alert("File size must be less than 10 MB");
                                            return;
                                        }
                                        const reader = new FileReader();
                                        reader.onload = (event) => {
                                            const img = new Image();
                                            img.src = event.target.result;
                                            setImage(img.src); // Use event.target.result for consistency
                                            setShowCropper(modal.name);
                                        };
                                        reader.readAsDataURL(file); // Ensure it reads as a data URL
                                    }
                                }}
                            />

                            {(croppedImage || modalInputs[modal.name]) != '' && (
                                <>
                                    <button className="image-input-clear" onClick={() => {
                                        setLoading(true);
                                        setImage(null);
                                        setCroppedImage(null);
                                        setModalInputs(prev => {
                                            const updatedInputs = {
                                                ...prev,
                                                [modal.name]: ''
                                            };
                                            return updatedInputs;
                                        });
                                        setLoading(false);
                                    }}>Clear Image</button>
                                </>
                            )}
                        </div>

                        {croppedImage && <img src={croppedImage} alt="Cropped" className="image-preview" />}
                    </>
                );
            case 'date':
                return (
                    <div className="modal-date-input-container">
                        <input
                            type="date"
                            className="modal-date"
                            value={modalInputs[modal.name] || ''}
                            onChange={(e) => setModalInputs(prev => ({
                                ...prev,
                                [modal.name]: e.target.value
                            }))}
                        />
                        <button 
                            className="modal-date-input-clear"
                            onClick={() => {
                                setModalInputs(prev => ({
                                    ...prev,
                                    [modal.name]: ''
                                }))
                            }}
                        >
                            Clear
                        </button>
                    </div>
                );
            
            default:
                return null;
        }
    };

    return (
        <>
            <div className="modal-overlay" onMouseDown={handleClickOutside}>
                <div className="modal-content" onMouseDown={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <div className="modal-header-text">
                            <h2 className="modal-title">Customize Your Page</h2>
                            {modals.some(modal => modal.modalDescription) && (
                                <p className="modal-description">
                                    {modals.map((modal, index) => (
                                        (((modal.condition === undefined) || (modal.condition.values.includes(choices[modal.condition.key])))) && (
                                            modal.modalDescription ? modal.modalDescription : ''
                                        )
                                    ))}
                                </p>
                            )}
                        </div>
                        <button className="modal-close-button" onClick={onModalClose}>&times;</button>
                    </div>

                    <div className="modal-sections">
                        {modals.map((modal, index) => (
                            ((modal.condition === undefined) || (modal.condition.values.includes(choices[modal.condition.key]))) && (
                                <div key={index} className="modal-section">
                                    <h3>{modal.header}</h3>
                                    <p>{modal.description}</p>
                                    {renderInput({modal})}
                                </div>
                            )
                        ))}
                    </div>
                    <button 
                        className="modal-save-button" 
                        onClick={() => {
                            setLoading(true);
                            onSave(modalInputs).finally(() => setLoading(false));
                        }}
                    >
                        {loading ? <div className="button-loader"></div> : "Save All Changes"}
                    </button>
                </div>
            </div>

            {image && showCropper && (
                <div className="image-crop-container" onMouseDown={(e) => {
                    if (e.target.className === 'image-crop-container') {
                        setImage(null);
                    }
                }}>
                    <div className="image-crop-content" onMouseDown={(e) => e.stopPropagation()}>
                        <div 
                            style = {{
                                position: 'relative',
                                width: '100%',
                                height: 300,
                                background: '#333',
                            }}
                        >
                            <Cropper
                                image={
                                    image
                                }
                                crop={crop}
                                rotation={rotation}
                                zoom={zoom}
                                aspect={1}
                                onCropChange={setCrop}
                                onRotationChange={setRotation}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                                />
                        </div>
                        <div className="cropping-tools">
                            <span className="scale-slider-label">Image zoom:    </span>
                            <input
                                type="range"
                                min="1"
                                max="5"
                                step="0.1"
                                value={zoom}
                                onChange={(e) => {
                                    setZoom(e.target.value);
                                }}
                            />
                        </div>
                        <button 

                            className="modal-save-button"
                            onClick={() => {
                                showCroppedImage(showCropper);
                                setImage(null);
                                setShowCropper(false);
                            }}
                        >Save</button>
                    </div>
                </div>
            )}
    </>
    );
};

export default GroupedModal;